export default {
  methods: {
    isEditable: pro => !pro.soft_deleted && !pro.account_claimed && pro.partnership_status != 'blocked',

    isPartner: pro => pro.partnership_status != 'blocked',

    isPaused:  pro => pro.partnership_status == 'paused',

    isDeleted: pro => pro.soft_deleted 
  },
}